import { render, staticRenderFns } from "./HistoryViewer.vue?vue&type=template&id=45b611ca"
import script from "./HistoryViewer.vue?vue&type=script&lang=js"
export * from "./HistoryViewer.vue?vue&type=script&lang=js"
import style0 from "./HistoryViewer.vue?vue&type=style&index=0&id=45b611ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports